<app-toast></app-toast>
<app-delete-confirmation-dialog title="{{ 'admin.finalize_show' | transloco }}"
    body="{{ 'admin.finalize_show_desc' | transloco }}" [showBinIcon]="false"></app-delete-confirmation-dialog>
<div class="h-screen flex flex-col items-center p-5 mobile:p-2">
    <!-- Top bar-->
    <div class="w-full">
        <app-admin-topbar></app-admin-topbar>
    </div>

    <!-- Tab Navigation -->
    <div class="w-full mb-4">
        <app-admin-navigation [isActiveNumber]="7"></app-admin-navigation>
    </div>

    <div class="flex-1 rounded-[16px] w-full border-[1px] border-neutral-200 shadow-sm">
        <div class="flex flex-col gap-2 h-full">
            <div class="flex flex-wrap justify-between items-center mx-4 py-4 mobile:flex-col mobile:p-6">
                <h3 class="font-bold mobile:mb-6">{{ 'admin.gas_invoice_check_review' | transloco }}</h3>
                <div class="flex flex-wrap gap-2 min-h-[70px] items-center mobile:flex-col mobile:h-auto">
                    <div class="w-[300px]">
                        <app-custom-dropdown [options]="statusDropdownOptions"
                            [(selectedOption)]="selectedStatusDropdown"
                            (selectedOptionChange)="applyStatusFilter()"></app-custom-dropdown>
                    </div>
                    <div class="w-[300px]">
                        <app-custom-dropdown [options]="filterDropdownOptions"
                            [(selectedOption)]="selectedFilterDropdown"
                            (selectedOptionChange)="applySelectedFilter()"></app-custom-dropdown>
                    </div>

                    <label class="input input-bordered flex items-center gap-2 w-auto max-w-[300px]">
                        <img src="assets/icons/search-normal.svg" alt="{{ 'shared.icon' | transloco }}">
                        <input type="text" class="grow" [(ngModel)]="searchTerm" (keyup)="applySearchFilter()"
                            placeholder="{{ 'shared.search' | transloco }}" />
                    </label>

                </div>
            </div>

            <!--Separator-->
            <div class="w-full h-[1px] bg-border"></div>

            <!-- Table -->
            <div
                class="overflow-x-auto max-w-ultrawide w-full justify-center mb-4 mobile:max-w-screen h-full block min-h-[70vh]">
                <table class="table w-full">
                    <!-- Header -->
                    <thead class="bg-primary-100 text-neutral-700 uppercase">
                        <tr class="max-h-[50px]">
                            <th class="border-b border-border px-4 py-4 font-normal">{{ 'admin.timestamp' |
                                transloco
                                }}</th>
                            <th class="border-b border-border px-4 py-4 font-normal">{{
                                'admin.client' |
                                transloco
                                }}</th>
                            <th class="border-b border-border px-4 py-4 font-normal">{{
                                'shared.labels.electricity.supplier'
                                |
                                transloco }}</th>
                            <th class="border-b border-border px-4 py-4 font-normal">{{ 'archive.overview.file_name' |
                                transloco }}</th>
                            <th class="border-b border-border px-4 py-4 font-normal">{{ 'shared.status' |
                                transloco }}</th>
                            <th class="border-b border-border px-4 py-4 font-normal text-end">{{ 'shared.details' |
                                transloco
                                }}</th>
                        </tr>
                    </thead>
                    <!-- Content -->
                    <tbody>
                        <ng-container *ngFor="let invoice of invoices; let i = index">
                            <tr [ngClass]="[expandedRow === i ? 'bg-neutral-200 text-black hover:bg-neutral-300' : 'hover:bg-neutral-300']"
                                class="max-h-[50px] hover:cursor-pointer" (click)="toggleDetails(i)">
                                <td class="border-b border-border px-4 py-4">{{ invoice.created_at | isoDateTime }}</td>
                                <td class="border-b border-border px-4 py-4">{{ invoice.company?.name || ''}}</td>
                                <td class="border-b border-border px-4 py-4">{{ (invoice.pdrs.length > 0 ?
                                    invoice.pdrs[0].supplier?.name || '' : '') }}</td>
                                <td class="border-b border-border px-4 py-4">{{ invoice.file!.filename || ''}}</td>
                                <td class="border-b border-border px-4 py-4">
                                    <app-admin-invoice-status-text 
                                        [invoiceStatus]="invoice.status"
                                        [visibilityStatus]="invoice.visibility_status"
                                        [reviewRequested]="invoice.review_requested"
                                        [adminApproved]="invoice.admin_approved">
                                    </app-admin-invoice-status-text>
                                </td>
                                <td class="border-b border-border px-4 py-4">
                                    <div class="flex gap-2 flex-wrap items-center justify-end">
                                        <div class="w-[150px] h-[40px]" (click)="$event.stopPropagation()">
                                            <app-custom-button buttonText="{{ 'invoice.download_report' | transloco }}"
                                                [isDisabled]="false" backgroundColor="bg-transparent"
                                                borderColor="border-transparent" textColor="text-black"
                                                hoverBackgroundColor="hover:bg-neutral-400"
                                                hoverBorderColor="hover:border-transparent"
                                                hoverTextColor="hover:text-black"
                                                leadingIcon="assets/icons/admin/download-black.svg"
                                                (buttonClick)="downloadFileDispute(invoice.id || '')"
                                                title="{{ 'invoice.download_report' | transloco }}">
                                            </app-custom-button>
                                        </div>
                                        <div class="w-[130px] h-[40px]">
                                            <app-custom-button
                                                [buttonText]="getButtonText(invoice)"
                                                [isDisabled]="isApproved(invoice)"  
                                                [backgroundColor]="getButtonBackgroundColor(invoice)"
                                                [borderColor]="getButtonBorderColor(invoice)"
                                                [textColor]="'text-white'"
                                                [hoverBackgroundColor]="getButtonHoverColor(invoice)"
                                                hoverBorderColor="hover:border-transparent"
                                                hoverTextColor="hover:text-white"
                                                (buttonClick)="updateStatus(invoice)">
                                            </app-custom-button>
                                        </div>

                                        @if(loadingExpandedRow)
                                        {
                                        <span class="loading loading-spinner loading-sm"></span>
                                        }

                                        <!-- Arrow up or down -->
                                        <svg xmlns="http://www.w3.org/2000/svg"
                                            class="w-5 h-5 transform transition-transform duration-200"
                                            [ngClass]="expandedRow === i ? 'rotate-180' : 'rotate-0'"
                                            viewBox="0 0 20 20" fill="currentColor">
                                            <path fill-rule="evenodd"
                                                d="M14.77 7.79a.75.75 0 00-1.06-.02L10 11.293 6.29 7.77a.75.75 0 00-1.04 1.08l4.23 4a.75.75 0 001.04 0l4.23-4a.75.75 0 00-.02-1.06z"
                                                clip-rule="evenodd" />
                                        </svg>
                                    </div>
                                </td>
                            </tr>
                            <tr *ngIf="expandedRow === i">
                                <td colspan="6" class="border-b border-border px-4 py-4">
                                    <app-admin-review-expanded-gas-invoice [toast]="toast" [fileUrl]="expandedFileUrl"
                                        [reloadCallbackFunction]="reloadCallbackFunction" [invoice]="invoice"
                                        [listOfLocations]="listOfLocations"
                                        [createLocationSuccessCallbackFunction]="createLocationSuccessCallbackFunction"
                                        [hardReloadCallbackFunction]="hardReloadCallbackFunction"
                                        [fileId]="expandedFileId"></app-admin-review-expanded-gas-invoice>
                                </td>
                            </tr>
                        </ng-container>
                        <tr *ngIf="loadedInvoices.length > 0 && !loadMoreHidden">
                            <td colspan="6">
                                <div class="w-full h-full flex justify-center items-start">
                                    <div class="w-[150px] h-[50px]">
                                        <app-custom-button buttonText="{{ 'shared.load_more' | transloco }}"
                                            [isDisabled]="false" backgroundColor="bg-neutral-500" textColor="text-white"
                                            borderColor="border:bg-neutral-500"
                                            hoverBackgroundColor="hover:bg-neutral-1200"
                                            (buttonClick)="loadMoreInvoices()">
                                        </app-custom-button>
                                    </div>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</div>